<template>
  <div>

        <el-table ref="myTable" class="table" size="mini" :data="tableData"  v-loading="loading" border :height="300">
          <el-table-column label="姓名" prop="elderlyName" width="100"></el-table-column>
          <el-table-column label="签到时间" prop="createTime" :formatter="getTime"></el-table-column>

          <el-table-column label="是否志愿者" prop="isVolunteer">
            <template slot-scope="scope">
              <span v-if="scope.row.isVolunteer ==1">是</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="Delete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,

      activityOrderCode:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  methods: {
    init(row){
      this.activityOrderCode = row.activityOrderCode;
      this.getList();
    },


    getTime(row,index,column){
      return timefilters(column)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){

      if(isSearch)this.currentPage = 1;

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ActivityOrderPeople/PageByActivityOrder",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

          activityOrderCode:this.activityOrderCode,
        }
      }).then((response) => {
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.$nextTick(()=>{
            this.$refs.myTable.doLayout();
          });
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },



    Delete(row) {
      this.$confirm("您确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {


        let dataForm = {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          activityOrderPeopleCode: row.activityOrderPeopleCode,
        };


        this.$axios({
          method: "post",
          url: this.$shopUrl + "ActivityOrderPeople/Delete",
          data:dataForm,
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            //this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
